import { createContext, useEffect, useState } from "react";

import type { ReactNode } from "react";

import { downdetectorConfigUrl } from "../config";

type DBAvailableContext = {
  isDBDown: boolean;
  dbDownMessage: string;
};

export const DBAvailableContext = createContext<DBAvailableContext>({
  isDBDown: false,
  dbDownMessage: "Please try again in a few minutes.",
});

const DBAvailableProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isDBDown, setIsDBDown] = useState(false);
  const [dbDownMessage, setDbDownMessage] = useState("Please try again in a few minutes.");

  useEffect(() => {
    fetch(downdetectorConfigUrl + "?t=" + Date.now()).then(async (response) => {
      let responseJson: { message?: string; maintenance?: boolean } = {};

      try {
        responseJson = await response.json();
      } catch (e) {
        // empty catch to avoid unexpected json parse errors
      }

      if ("maintenance" in responseJson) {
        setIsDBDown(responseJson.maintenance as boolean);
      }

      if (responseJson.maintenance && "message" in responseJson) {
        setDbDownMessage(responseJson.message as string);
      }
    });
  }, []);

  return (
    <DBAvailableContext.Provider value={{ isDBDown, dbDownMessage }}>
      {children}
    </DBAvailableContext.Provider>
  );
};

export default DBAvailableProvider;
